export enum TemplateView {
    View,
    Edit,
    CreateNew
}